class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));

        this.handleGiftProduct();

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }

  handleGiftProduct() {
    fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      var miniCart = document.querySelector('mini-cart');
      const giftThreshold = window.giftSettings.giftThreshold;
      const giftProductId = window.giftSettings.giftProductId;
      const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
  
      if (cart.total_price > giftThreshold) {
        const giftProductInCart = cart.items.some(item => item.id === giftProductId);
  
        if (!giftProductInCart) {
          // Add the gift product to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: giftProductId,
                quantity: 1
              }],
              sections: sections,
              sections_url: window.location.pathname
            })
          })
          .then(response => response.json())
          .then(response => {
            miniCart.renderContents(response);
            document.querySelectorAll('.free-gift-text').forEach(element => {
              element.style.display = 'none';
            });
          })
          .catch(error => {
            console.error('Error adding gift product:', error);
          });
        }
      } else {
        const giftLineItem = cart.items.find(item => item.id === giftProductId);
  
        if (giftLineItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: giftLineItem.key,
              quantity: 0,
              sections: sections,
              sections_url: window.location.pathname
            })
          })
          .then(response => response.json())
          .then(response => {
            miniCart.renderContents(response);
            document.querySelectorAll('.free-gift-text').forEach(element => {
              element.style.display = 'block';
            });
          })
          .catch(error => {});
        }
      }
    })
    .catch((error) => {
      console.error('Error fetching cart:', error);
    });
  }
}
customElements.define('cart-items', CartItems);


// ---------------------------------------------
// CART PROGRESS BAR / FREE SHIPPING / DISCOUNT
// ---------------------------------------------

// Update cart progress bar
// function updateCartProgressBar(cart) {
//   let topwearCount = 0;
//   const freeShippingThreshold = 800;

//   // Total cart value in rupees
//   const cartTotal = cart.items.reduce((sum, item) => sum + item.price * item.quantity, 0) / 100;

//   // Free shipping message
//   const shippingMsg = cartTotal >= freeShippingThreshold
//     ? `✅ Free Shipping Applied!`
//     : `Add ₹${(freeShippingThreshold - cartTotal).toFixed(0)} more for Free Shipping`;

//   // Topwear discount
//   cart.items.forEach(item => {
//     if (item.product_type.toLowerCase() === 'topwear') topwearCount += item.quantity;
//   });

//   let discountMsg = '';
//   if (topwearCount >= 3) discountMsg = `Buy 3 Topwear: ₹300 Off!`;
//   else if (topwearCount >= 2) discountMsg = `Buy 2 Topwear: ₹200 Off!`;
//   else if (topwearCount === 1) discountMsg = `Add 1 more Topwear for ₹200 Off`;

//   // Progress bar animation
//   const progressPercent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
//   const barFill = document.querySelector('.cart-progress-bar-fill');
//   const msgEl = document.querySelector('.cart-progress-msg');

//   if (barFill) {
//     barFill.style.transition = 'width 0.5s ease';
//     barFill.style.width = `${progressPercent}%`;
//   }
//   if (msgEl) msgEl.innerText = `${shippingMsg} | ${discountMsg}`;
// }

// // Initialize progress bar (retry until elements exist)
// function initCartProgressBar() {
//   const barEl = document.querySelector('.cart-progress-bar-fill');
//   const msgEl = document.querySelector('.cart-progress-msg');

//   if (barEl && msgEl) {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => updateCartProgressBar(cart));
//   } else {
//     setTimeout(initCartProgressBar, 200);
//   }
// }

// // Page load
// document.addEventListener('DOMContentLoaded', initCartProgressBar);

// // Update progress bar on cart update
// document.addEventListener('cart:updated', (event) => {
//   let cart;
//   try {
//     cart = JSON.parse(event.detail.cart);
//   } catch {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => updateCartProgressBar(cart));
//     return;
//   }
//   updateCartProgressBar(cart);
// });

// // MutationObserver for mini-cart drawer open (optional, for dynamic loading)
// const miniCartContainer = document.querySelector('.mini-cart__main');
// if (miniCartContainer) {
//   const observer = new MutationObserver(() => {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => updateCartProgressBar(cart));
//   });
//   observer.observe(miniCartContainer, { childList: true, subtree: true });
// }


class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
